/* eslint-disable no-unused-vars */
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link, useNavigate } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import {
   Grid,
   TextField,
   Box,
   Typography,
   FormControl,
   InputLabel,
   Select,
   MenuItem,
   Paper,
   FormHelperText
} from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import * as Yup from 'yup'
import MultiSelect from '../../Components/MUI/MultiSelect'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '../../Utils/RichEditor';
// import { useGetLeadsQuery } from '../../Redux/Service/LeadApi';
import { useGetProvidersQuery } from '../../Redux/Service/ProviderApi'
import { useCreateEstimationMutation } from '../../Redux/Service/EstimateApi'
import { useGetTechnologyStackListQuery } from '../../Redux/Service/TechnologyStackApi'
import { toast } from 'react-toastify'
import Loading from '../../Components/Loading'
import { useGetCurrenciesQuery } from '../../Redux/Service/CurrencyApi'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'react-bootstrap'
import DeleteIcon from '@mui/icons-material/Delete'
import API from '../../Web/Instance'
import { setTechnologyStacks } from '../../Redux/Reducers/Contracts/ContractSlice'
import { useGetopportunitiesQuery } from '../../Redux/Service/OpportunityApi'
import InfiniteAutocomplete from '../../Components/InfiniteAutocomplete'
import UploadLogo from '../../Assets/upload.svg'
import StyledDashboardLayout from '../style'
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

function EstimateAdd() {
   const navigate = useNavigate()
   const [loading, setLoading] = useState(true)
   const [search, setSearch] = useState('')
   const [page, setPage] = useState(1)
   const [techStackArr, setTechStackArr] = useState([])
   const [uploadFile, setUploadFile] = useState('Upload Estimate File')
   const fileRef = useRef();
   const {
      data: opportunityData,
      isLoading: isLoadingForOpportunity,
      isError: isErrorForOpportunity,
      error: errorForOpportunity,
   } = useGetopportunitiesQuery({ limit: 10, name: search, page })
   const {
      data: providerData,
      isLoading: isLoadingForProvider,
      isError: isErrorForProvider,
      error: errorForProvider,
   } = useGetProvidersQuery()
   const { data: techData, isLoading: isLoadingForTech } =
      useGetTechnologyStackListQuery()
   const [selectedTechnologies, setSelectedTechnologies] = useState([])
   const [technologyOptions, setTechnologyOptions] = useState([])
   const [createEstimation] = useCreateEstimationMutation()
   const [symbol, setSymbol] = useState('$')
   const debounceTimeout = useRef(null)
   const [descriptionLength, setDescriptionLength] = useState(0)
   // const [initialState, setInitialState] = useState({
   //   opportunityId: "",
   // });
   // const dispatch = useDispatch();
   // const total_options = 600000;
   // const BATCH_SIZE = 10;
   // const fullOptionsRef = useRef([]);
   const [visibleOptions, setVisibleOptions] = useState([])
   const [selectedOption, setSelectedOption] = useState(null)

   React.useEffect(() => {
      API.get(`technology-stack/list-technology`).then((response) => {
         setTechnologyOptions(response.data?.response)
      })
   }, [])

   const {
      data: currencies,
      isLoading: isLoadingForCurrency,
      error: errorForCurrency,
   } = useGetCurrenciesQuery()

   const initialValues = {
      opportunityId: '',
      serviceProviderId: '',
      name: '',
      description: '',
      revisionVersion: '',
      revisionComment: '',
      totalHours: '',
      totalCost: '',
      currencyId: 1,
      techStack: [],
      file: '',
   }

   const handleAddTechnology = (technologyId, setFieldValue) => {
      const selectedTech = technologyOptions.find(
         (item) => item.id === technologyId,
      )
      if (
         selectedTech &&
         !selectedTechnologies.includes(selectedTech.technology)
      ) {
         const updatedTechnologies = [
            ...selectedTechnologies,
            selectedTech.technology,
         ]
         setSelectedTechnologies(updatedTechnologies)
         setFieldValue('techStack', updatedTechnologies)
      }
   }

   const handleRemoveTechnology = (technology, setFieldValue) => {
      const updatedTechnologies = selectedTechnologies.filter(
         (tech) => tech !== technology,
      )
      setSelectedTechnologies(updatedTechnologies)
      setFieldValue('techStack', updatedTechnologies)
   }

   const handleScroll = (event) => {
      const listboxNode = event.currentTarget
      const bottom =
         listboxNode.scrollHeight - listboxNode.scrollTop <=
         listboxNode.clientHeight + 5

      if (bottom) {
         setPage((prev) => prev + 1)
      }
   }
   const handleSelectOption = (
      event,
      value,
      reason,
      setFieldValue,
      setFieldTouched,
   ) => {
      setSelectedOption(value)
      setFieldValue(
         'opportunityId',
         reason === 'selectOption' ? value.id : null,
      )
      if (reason === 'clear') {
         setFieldTouched('opportunityId', true)
      }
   }

   const handleSearch = (event, value) => {
      clearTimeout(debounceTimeout.current)
      debounceTimeout.current = setTimeout(() => {
         setSearch(value)
      }, 300)
   }

   const currencySymbolSet = (currencyId, setFieldValue) => {
      setFieldValue('currencyId', currencyId)
      const selectedCurrency = currencies?.response?.find(
         (val) => val.id === currencyId,
      )
      setSymbol(selectedCurrency?.symbol ?? '$')
   }

   const validationSchema = Yup.object().shape({
      opportunityId: Yup.number().required().typeError(),
      serviceProviderId: Yup.number()
         .typeError('Service Provider ID must be a number')
         .required('Service Provider ID is required'),
      name: Yup.string().required('Name is required').max(100, "Name must be at most 100 characters long"),
      description: Yup.string().required('Description is required').max(1000, 'Description must be at most 1000 characters long'),
      revisionVersion: Yup.string().required('Revision Version is required').max(250, "Revision Version must be at most 250 characters long"),
      revisionComment: Yup.string().required('Revision Comment is required').max(100, "Revision Comment must be at most 100 characters long"),
      totalHours: Yup.number()
         .typeError('Total Hours must be a number')
         .required('Total Hours time in days is required')
         .positive("Total Hours time in days should be positive number")
         .max(9999, 'Total Hours time in days must be at most 9999'),
      totalCost: Yup.number()
         .typeError('Total Cost must be a number')
         .required('Total Cost is required')
         .positive("Total Cost should be positive number")
         .max(99999999, "Total Cost must be at most 8 digits"),
      techStack: Yup.array()
         .of(Yup.string().required('Technology is required'))
         .min(1, 'At least one technology is required'),
      file: Yup.mixed().required('File is required'),
   })

   useEffect(() => {
      const newData = opportunityData?.response?.data ?? []
      setVisibleOptions((prevOptions) => {
         const existingIds = new Set(prevOptions.map((opt) => opt.id))
         const uniqueNewData = newData.filter((opt) => !existingIds.has(opt.id))
         return [...prevOptions, ...uniqueNewData]
      })
   }, [opportunityData?.response?.data])

   useEffect(() => {
      if (
         !isLoadingForOpportunity &&
         !isLoadingForProvider &&
         !isLoadingForTech
      ) {
         setTechStackArr(techData?.response?.map((tech) => tech.technology))
         setLoading(false)
      }
   }, [
      isLoadingForOpportunity,
      isLoadingForProvider,
      isLoadingForTech,
      techData,
   ])

   const removeFile = (setFieldValue) => {
      fileRef.current.value = null;
      setUploadFile(null);
      setFieldValue('file', null);
   };

   const handleSubmit = async (values, { setSubmitting }) => {
      try {
         setSubmitting(true);
         const techStackIds = values.techStack
            .map((techName) => {
               const tech = technologyOptions.find(
                  (t) => t.technology === techName,
               )
               return tech ? tech.id : null
            })
            .filter((id) => id !== null)

         const submitData = {
            ...values,
            techStack: techStackIds,
            currencyId: parseInt(values.currencyId),
         }

         const result = await createEstimation(submitData)
         if (result.error) {
            toast.error(result.error.data?.message)
         } else {
            toast.success('Estimate created successfully')
            navigate('/estimate')
         }
      } catch (error) {
         toast.error('Creation failed. Please try again.')
      } finally {
         setSubmitting(false);
      }
   }

   const onFileChange = (event, setFieldValue) => {
      const file = event.target.files[0]

      // check file type
      if (
         file.type !==
         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
         file.type !== 'application/vnd.ms-excel'
      ) {
         toast.error('Please select valid file type')
         return
      }
      setFieldValue('file', file)
      setUploadFile(`File :${file.name}`)
   }

   if (loading) {
      return <Loading />
   }

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header">
               <div className="container-fluid">
                  <div className="d-flex justify-content-between mb-2">
                     <div className="pageTitle">
                        <h1 className="m-0">Add Estimation</h1>
                     </div>
                     <div className="btnWrap">
                        <Link to="/estimate" className="btn addBtn">
                           {' '}
                           <ArrowBackIcon /> Back
                        </Link>
                     </div>
                  </div>
               </div>
            </div>
            <div className="card customCard p-3 m-3">
               {/* <div className="card-header">
            <h3 className="card-title">Estimation</h3>
          </div> */}
               {isLoadingForOpportunity || isLoadingForProvider ? (
                  <div>Loading...</div>
               ) : errorForOpportunity || errorForProvider ? (
                  <div>
                     Error: {errorForOpportunity?.message}
                     {errorForProvider?.message}
                  </div>
               ) : (
                  <Formik
                     initialValues={initialValues}
                     validationSchema={validationSchema}
                     onSubmit={(values, actions) => handleSubmit(values, actions)}
                  >
                     {({
                        isSubmitting,
                        values,
                        setFieldValue,
                        setFieldTouched,
                        touched,
                        setSubmitting,
                        errors,
                        handleBlur,
                     }) => (
                        <Form>
                           <Box
                              className="card-body"
                              sx={{ padding: '15px 0' }}
                           >
                              <Grid container spacing={2}>
                                 <Grid item md={12} xs={12}>
                                    <Box>
                                       <Grid container spacing={4}>
                                          <Grid item xs={12}>
                                             {isLoadingForOpportunity ? (
                                                <div>Loading...</div>
                                             ) : isErrorForOpportunity ? (
                                                <div>
                                                   Error:{' '}
                                                   {
                                                      errorForOpportunity?.message
                                                   }
                                                </div>
                                             ) : (
                                                <FormControl fullWidth>
                                                   <label htmlFor="opportunity">
                                                      Opportunity*
                                                   </label>
                                                   {/* <InputLabel id="demo-select-small-label" sx={touched.opportunityId && Boolean(errors.opportunityId) ? { color: "hwb(353deg 2% 13%)" } : {}}>Opportunity</InputLabel> */}
                                                   <InfiniteAutocomplete
                                                      onBlur={handleBlur}
                                                      value={selectedOption}
                                                      onChange={(
                                                         event,
                                                         value,
                                                         reason,
                                                      ) =>
                                                         handleSelectOption(
                                                            event,
                                                            value,
                                                            reason,
                                                            setFieldValue,
                                                            setFieldTouched,
                                                         )
                                                      }
                                                      options={visibleOptions}
                                                      onScroll={handleScroll}
                                                      inputValue={search}
                                                      setInputValue={
                                                         handleSearch
                                                      }
                                                      total_options={
                                                         'Opportunity'
                                                      }
                                                      error={Boolean(
                                                         touched.opportunityId &&
                                                         errors.opportunityId,
                                                      )}
                                                      helperText={
                                                         touched.opportunityId &&
                                                         errors.opportunityId
                                                      }
                                                   />
                                                   {/* <ErrorMessage name="opportunityId" className='error-message' component="div" style={{ color: 'red' }} /> */}
                                                </FormControl>
                                             )}
                                          </Grid>

                                          <Grid item md={6} xs={12}>
                                             {isLoadingForProvider ? (
                                                <div>Loading...</div>
                                             ) : isErrorForProvider ? (
                                                <div>
                                                   Error:{' '}
                                                   {errorForProvider?.message}
                                                </div>
                                             ) : (
                                                <FormControl fullWidth>
                                                   {/* <label htmlFor="serviceProviderId">Service Provider</label> */}
                                                   <InputLabel
                                                      id="demo-select-small-label"
                                                      sx={
                                                         touched.serviceProviderId &&
                                                            Boolean(
                                                               errors.serviceProviderId,
                                                            )
                                                            ? {
                                                               color: 'hwb(353deg 2% 13%)',
                                                            }
                                                            : {}
                                                      }
                                                   >
                                                      Service Provider*
                                                   </InputLabel>
                                                   <Field
                                                      label="Service Provider"
                                                      name="serviceProviderId"
                                                      as={Select}
                                                      labelId="demo-select-small-label"
                                                      id="demo-simple-select"
                                                      onChange={(event) =>
                                                         setFieldValue(
                                                            'serviceProviderId',
                                                            event.target.value,
                                                         )
                                                      }
                                                      error={
                                                         touched.serviceProviderId &&
                                                         Boolean(
                                                            errors.serviceProviderId,
                                                         )
                                                      }
                                                   // helperText={
                                                   //    touched.serviceProviderId &&
                                                   //    errors.serviceProviderId
                                                   // }
                                                   >
                                                      {providerData?.response?.map(
                                                         (val, index) => (
                                                            <MenuItem
                                                               key={index}
                                                               value={val.id}
                                                            >
                                                               {val.name}
                                                            </MenuItem>
                                                         ),
                                                      )}
                                                   </Field>
                                                   {/* <ErrorMessage
                                                      name="serviceProviderId"
                                                      className="error-message"
                                                      component="div"
                                                      style={{ color: 'red' }}
                                                   /> */}
                                                   {touched.serviceProviderId && (<FormHelperText sx={{ color: '#d32f2f', margin: '3px 14px' }}>
                                                      {touched.serviceProviderId && errors.serviceProviderId} </FormHelperText>)}
                                                </FormControl>
                                             )}
                                          </Grid>
                                          <Grid item md={6} xs={12}>
                                             <FormControl fullWidth>
                                                {/* <label htmlFor="CurrencyId">Currency</label> */}
                                                <InputLabel id="currency-label">
                                                   Currency*
                                                </InputLabel>
                                                <Field
                                                   label="Currency"
                                                   name="currencyId"
                                                   as={Select}
                                                   labelId="currency-label"
                                                   onChange={(event) =>
                                                      currencySymbolSet(
                                                         event.target.value,
                                                         setFieldValue,
                                                      )
                                                   }
                                                >
                                                   {currencies?.response?.map(
                                                      (val, index) => (
                                                         <MenuItem
                                                            key={index}
                                                            value={val.id}
                                                         >
                                                            {val.name} (
                                                            {val.code})
                                                         </MenuItem>
                                                      ),
                                                   )}
                                                </Field>
                                                <ErrorMessage
                                                   name="currencyId"
                                                   className="error-message"
                                                   component="div"
                                                   style={{ color: 'red' }}
                                                />
                                             </FormControl>
                                          </Grid>
                                          <Grid item md={6} xs={12}>
                                             {/* <label htmlFor="name">Name</label> */}
                                             <Field
                                                fullWidth
                                                label="Name*"
                                                name="name"
                                                variant="outlined"
                                                type="text"
                                                as={TextField}
                                                error={
                                                   touched.name &&
                                                   Boolean(errors.name)
                                                }
                                                helperText={
                                                   touched.name && errors.name
                                                }
                                             />
                                          </Grid>
                                          <Grid item md={6} xs={12}>
                                             {/* <label htmlFor="revisionVersion">Revision Version</label> */}
                                             <Field
                                                fullWidth
                                                label="Revision Version*"
                                                name="revisionVersion"
                                                variant="outlined"
                                                type="text"
                                                as={TextField}
                                                error={
                                                   touched.revisionVersion &&
                                                   Boolean(
                                                      errors.revisionVersion,
                                                   )
                                                }
                                                helperText={
                                                   touched.revisionVersion &&
                                                   errors.revisionVersion
                                                }
                                             />
                                          </Grid>
                                          <Grid item md={12} xs={12}>
                                             <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                   <FormControl fullWidth>
                                                      {/* <label htmlFor="technology">Technology Stack</label> */}
                                                      <InputLabel id="tech-select-label">
                                                         Technology Stack*
                                                      </InputLabel>
                                                      <Select
                                                         labelId="tech-select-label"
                                                         label="Select Technology"
                                                         onChange={(e) =>
                                                            handleAddTechnology(
                                                               e.target.value,
                                                               setFieldValue,
                                                            )
                                                         }
                                                         name="technology"
                                                         onError={touched.techStack && errors.techStack}

                                                      >
                                                         <MenuItem
                                                            value=""
                                                            disabled
                                                         >
                                                            Select Technology
                                                         </MenuItem>
                                                         {technologyOptions.map(
                                                            (option) => (
                                                               <MenuItem
                                                                  key={
                                                                     option.id
                                                                  }
                                                                  value={
                                                                     option.id
                                                                  }
                                                               >
                                                                  {
                                                                     option.technology
                                                                  }
                                                               </MenuItem>
                                                            ),
                                                         )}
                                                      </Select>
                                                      <FormHelperText sx={{ color: "red" }}>
                                                         {touched.techStack && errors.techStack}
                                                      </FormHelperText>
                                                   </FormControl>

                                                   {/* <ErrorMessage
                                                      name="techStack"
                                                      component="div"
                                                      style={{ color: 'red' }}
                                                   /> */}
                                                </Grid>
                                                <Grid item xs={12}>
                                                   <Typography variant="subtitle1">
                                                      Selected Technologies:
                                                   </Typography>
                                                   <Box
                                                      sx={{
                                                         display: "flex",
                                                         flexWrap: "wrap",
                                                         gap: 1,
                                                      }}
                                                   >
                                                      {selectedTechnologies?.map((tech, index) => (
                                                         <Box
                                                            key={index}
                                                            sx={{
                                                               display: "flex",
                                                               alignItems: "center",
                                                               px: 1,
                                                               py: 0.5,
                                                               borderRadius: 1,
                                                               bgcolor: "grey.100",
                                                            }}
                                                         >
                                                            <Typography variant="body2">
                                                               {tech}
                                                            </Typography>

                                                            <IconButton
                                                               onClick={() =>
                                                                  handleRemoveTechnology(
                                                                     tech,
                                                                     setFieldValue,
                                                                  )
                                                               }
                                                               sx={{
                                                                  ml: 0.25,
                                                                  p: 0.25,
                                                                  color: "text.secondary",
                                                                  "&:hover": {
                                                                     bgcolor: "transparent",
                                                                     color: "error.main",
                                                                  },
                                                               }}
                                                            >
                                                               <CloseIcon sx={{ fontSize: 14 }} />
                                                            </IconButton>
                                                         </Box>
                                                      ))}
                                                   </Box>
                                                </Grid>
                                             </Grid>
                                          </Grid>
                                          <Grid item md={6} xs={12}>
                                             {/* <label htmlFor="totalhours">Total Hours</label> */}
                                             <Field
                                                fullWidth
                                                label="Total Hours*"
                                                name="totalHours"
                                                variant="outlined"
                                                type="number"
                                                as={TextField}
                                                error={
                                                   touched.totalHours &&
                                                   Boolean(errors.totalHours)
                                                }
                                                helperText={
                                                   touched.totalHours &&
                                                   errors.totalHours
                                                }
                                             />
                                          </Grid>

                                          <Grid item md={6} xs={12}>
                                             {/* <label htmlFor="totalcost">Total Cost</label> */}
                                             <Field
                                                fullWidth
                                                label="Total Cost*"
                                                name="totalCost"
                                                variant="outlined"
                                                type="number"
                                                as={TextField}
                                                error={
                                                   touched.totalCost &&
                                                   Boolean(errors.totalCost)
                                                }
                                                helperText={
                                                   touched.totalCost &&
                                                   errors.totalCost
                                                }
                                             />
                                          </Grid>
                                          <Grid item xs={12}>
                                             {/* <label htmlFor="revisioncommnet">Revision Comment</label> */}
                                             <Field
                                                fullWidth
                                                label="Revision Comment*"
                                                name="revisionComment"
                                                variant="outlined"
                                                type="text"
                                                as={TextField}
                                                error={
                                                   touched.revisionComment &&
                                                   Boolean(
                                                      errors.revisionComment,
                                                   )
                                                }
                                                helperText={
                                                   touched.revisionComment &&
                                                   errors.revisionComment
                                                }
                                             />
                                          </Grid>
                                          {/* <Grid item xs={9}>
                            <Field
                              label="Tech Stack"
                              name="techStack"
                              variant="outlined"
                              as={Select}
                              render={() => (
                                <MultiSelect
                                  options={techStackArr}
                                  selectedOptions={values.techStack}
                                  onChange={selectedOptions => setFieldValue("techStack", selectedOptions)}
                                  placeholder="Select Tech Stack"
                                />
                              )}
                              error={touched.techStack && Boolean(errors.techStack)}
                              helperText={touched.techStack && errors.techStack}
                            />
                            <ErrorMessage name="techStack" className='error-message invalid-feedback' component="div" />
                          </Grid> */}

                                          <Grid item md={12} xs={12}>
                                             <Box>
                                                {/* <Typography variant="h4" gutterBottom align="center">
                                  Description
                                </Typography> */}
                                                <Grid container spacing={2}>
                                                   <Grid item xs={12}>
                                                      {/* <label htmlFor="description">Description</label> */}
                                                      <Field name="description">
                                                         {({ field, form }) => (
                                                            <div>
                                                               <label
                                                                  style={{
                                                                     display:
                                                                        'block',
                                                                     marginBottom: 8,
                                                                     fontWeight: 600,
                                                                  }}
                                                               >
                                                                  Description*
                                                               </label>
                                                               <Paper
                                                                  elevation={1}
                                                                  style={{
                                                                     padding: 12,
                                                                  }}
                                                               >
                                                                  <style>{`.ck-editor__editable_inline{min-height:220px;}`}</style>
                                                                  <CKEditor
                                                                     editor={
                                                                        ClassicEditor
                                                                     }
                                                                     data={
                                                                        form
                                                                           .values
                                                                           .description ||
                                                                        ''
                                                                     }
                                                                     config={{
                                                                        placeholder:
                                                                           'Enter description...',
                                                                     }}
                                                                     onChange={(
                                                                        event,
                                                                        editor,
                                                                     ) => {
                                                                        const data =
                                                                           editor.getData()
                                                                        // set the Formik field value
                                                                        form.setFieldValue(
                                                                           'description',
                                                                           data,
                                                                        )
                                                                        // strip HTML and non-breaking spaces when counting
                                                                        // const plain =
                                                                        //    data
                                                                        //       .replace(
                                                                        //          /<[^>]*>/g,
                                                                        //          '',
                                                                        //       )
                                                                        //       .replace(
                                                                        //          /&nbsp;/g,
                                                                        //          ' ',
                                                                        //       )
                                                                        //       .trim()
                                                                        setDescriptionLength(
                                                                           data.length,
                                                                        )
                                                                     }}
                                                                     onBlur={() =>
                                                                        form.setFieldTouched(
                                                                           'description',
                                                                           true,
                                                                        )
                                                                     }
                                                                     className="TextEditor"
                                                                  />
                                                               </Paper>
                                                               <div
                                                                  style={{
                                                                     marginTop: 8,
                                                                     display:
                                                                        'flex',
                                                                     justifyContent:
                                                                        'space-between',
                                                                     alignItems:
                                                                        'center',
                                                                  }}
                                                               >
                                                                  <ErrorMessage
                                                                     name="description"
                                                                     className="error-message"
                                                                     component="div"
                                                                  />
                                                                  <Typography
                                                                     variant="caption"
                                                                     color="text.secondary"
                                                                  >
                                                                     {
                                                                        descriptionLength
                                                                     }{' '}
                                                                     characters
                                                                  </Typography>
                                                               </div>
                                                            </div>
                                                         )}
                                                      </Field>
                                                      {/* ErrorMessage fallback removed because shown above with char count */}
                                                   </Grid>
                                                </Grid>
                                             </Box>
                                          </Grid>

                                          <Grid item xs={12} gap={4}>
                                             <Paper
                                                elevation={2}
                                                className="uploadFile"
                                             >
                                                <Box>
                                                   <img
                                                      src={UploadLogo}
                                                      alt="Logo"
                                                      className="uploadLogo"
                                                   />
                                                   <Typography
                                                      variant="body2"
                                                      sx={{ mt: 1 }}
                                                   >
                                                      Drag and Drop or{' '}
                                                      <Link
                                                         component="button"
                                                         variant="body2"
                                                         className="chooseFile"
                                                         onClick={() =>
                                                            document
                                                               .getElementById(
                                                                  'file',
                                                               )
                                                               .click()
                                                         }
                                                      >
                                                         Choose file
                                                      </Link>{' '}
                                                      to upload*
                                                      <div style={{ color: "green" }}>*Only application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel formats are allowed</div>
                                                   </Typography>
                                                   <Box style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                      <Typography
                                                         variant="caption"
                                                         color="text.secondary"
                                                         style={{fontSize: '16px'}}
                                                      >
                                                         {uploadFile}
                                                      </Typography>
                                                      {(uploadFile && uploadFile !== 'Upload Estimate File') && <button
                                                         type="button"
                                                         onClick={() => removeFile(setFieldValue)}
                                                         style={{
                                                            border: 'none',
                                                            backgroundColor: 'red',
                                                            color: '#fff',
                                                            width: '24px',
                                                            height: '24px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            fontSize: '20px',
                                                            borderRadius: '100%',
                                                         }}
                                                      >&times;
                                                      </button>}
                                                   </Box>
                                                </Box>

                                                {/* Hidden File Input */}
                                                <input
                                                   ref={fileRef}
                                                   id="file"
                                                   type="file"
                                                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                   style={{ display: 'none' }}
                                                   onChange={(event) =>
                                                      onFileChange(
                                                         event,
                                                         setFieldValue,
                                                      )
                                                   }
                                                />
                                             </Paper>
                                             <ErrorMessage
                                                name="file"
                                                component="div"
                                                className="error-message"
                                             />

                                          </Grid>
                                       </Grid>
                                    </Box>
                                 </Grid>
                              </Grid>
                              <button
                                 type="submit"
                                 className="btn commonBtn mt-2"
                                 disabled={isSubmitting}
                              >
                                 {isSubmitting ? 'Creating...' : 'Submit'}
                              </button>
                           </Box>
                        </Form>
                     )}
                  </Formik>
               )}
            </div>
         </div>
      </StyledDashboardLayout>
   )
}
export default EstimateAdd
